import {PropertyBase} from "./PropertyBase";
import {RNTextInput} from "shared/controls/SingleInputs/RNTextInput";
import * as React from "react";
import {ReactElement} from "react";
import {FontAwesomeIcon} from "shared/core/Controls/FontAwesome/FontAwesomeIcon";
import {faCalculator} from "@fortawesome/free-solid-svg-icons/faCalculator";

export class SimpleTextProperty extends PropertyBase{
    public label:string="Label";
    public Placeholder:string='';
    public Tooltip:ReactElement=null;
    public hint:string;
    public MaxLength:number=undefined;
    private Description:JSX.Element=null;

    public SetPlaceholder(value:string){
        this.Placeholder=value;
        return this;
    }


    public SetMaxLength(length)
    {
        this.MaxLength=length;
        return this;
    }

    public SetDescription(element:JSX.Element)
    {
        this.Description=element;
        return this;
    }

    public SetTooltip(content:ReactElement)
    {
        this.Tooltip=content;
        return this;
    }




    public SubRenderer(): React.ReactNode {

        let value=this.ExternalValue;
        if(value==null)
            value=this.GetOptionValue();



        return (
            <React.Fragment>
                <div className={'rncontrol'}>
                    {   this.label!=''&&
                    <label style={{width: '100%', display: 'block',fontWeight:'bold'}}>{this.label}
                        {
                            this.hint&&
                            <span style={{display:'block',fontSize:12,color:'#5f5f5f',fontStyle:'italic'}}>{this.hint}</span>
                        }
                        {this.GetTooltip(this.Tooltip)}
                    </label>
                    }

                </div>
                <input style={{width:'100%'}} maxLength={this.MaxLength} placeholder={this.Placeholder} type={'text'} disabled={this.disabled}  className={'rncontrol'} value={value} onChange={(e)=>{this.SetValue(e.target.value)}}/>
                {this.Description!=null&&<div style={{marginTop:-10,marginBottom:10}}>{this.Description}</div>}
            </React.Fragment>
        )
    }

    public SetHint(hint:string){
        this.hint=hint;
        return this;
    }

    private SetValue(value: string) {
        this.SetOptionValue(value);
    }


}